import { type HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { Logger } from '@shared/helpers/logger';

/**
 * Global Error Interceptor for non-authorization errors.
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = new Logger('Error Interceptor');

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        let errorMessage = 'An unknown error occurred!';
        errorMessage =
          error.error instanceof ErrorEvent
            ? `Error: ${error.error.message}`
            : `Error Code: ${error.status}\nMessage: ${error.message}`;

        logger.error(errorMessage);
      }

      return throwError(() => error);
    })
  );
};
